'use client';

export function useIsWTGamesApp() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent || '';
  return /\bWTGamesApp\b/i.test(ua);
}
